export class UsersPasswordForgottenPage {
    constructor() {

        this.formElement = $('#password-forgotten-form');

        this.sendBtn = $('#send-password-reset-btn');

        this.sendBtn.click(() => {

            this.sendPasswordReset();
        });

        this.modal = $('#password-reset-send-modal');
    }

    sendPasswordReset() {


        this.formElement[0].classList.add('was-validated');

        if(this.formElement[0].checkValidity()) {

            this.sendBtn.addClass('loading disabled');

            $.post('/Users/doPasswordReset', this.formElement.serialize())
                .done((response) => {
                    this.formElement[0].reset();
                    this.formElement[0].classList.remove('was-validated');

                    this.modal.modal({
                        backdrop: 'static',
                        keyboard: false
                    }).modal('show');
                }).fail((error) => {
                // TODO ERROR HANDLING
            }).always(() => {
                this.sendBtn.removeClass('loading disabled');
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", (e) => new UsersPasswordForgottenPage());
